import React from "react";
import { RaisedButton } from "material-ui";
import InfoNotice from "./info-notice.jsx";
import PassRuleEditor from "./pass-rule-editor.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import UserStore from "../../stores/UserStore";

class PassRulesEditorNonAtomic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return {};
  }

  onAdd(isFirst) {
    this.props.onAdd({
      type: "ticket",
      target: {},
      result: {},
      restrictions: {}
    });
  }

  save(i, value) {
    if (value === null) {
      // Delete
      this.props.onDelete(i);
    } else {
      this.props.onChange(i, value);
    }
  }

  render() {
    const isPassBucket = this.props.mode === "pass_bucket";
    const isMembership = this.props.isMembership;
    const { passRules: rules } = this.props;
    const items = rules.map((r, i) => {
      return (
        <PassRuleEditor
          key={`${this.props.orderKey}-${i}`}
          index={i}
          rule={r}
          mode={this.props.mode}
          parentId={this.props.parentId}
          parent={this.props.parent}
          eventBucketId={this.props.eventBucketId}
          getEventBucketById={this.props.getEventBucketById}
          getEventBuckets={this.props.getEventBuckets}
          onChange={!isPassBucket ? e => this.save(i, e) : null}
          save={e => this.save(i, e)}
          canShiftUp={i > 0}
          canShiftDown={i < rules.length - 1}
          hasMultipleTicketBuckets={rules.length > 1}
          shiftPosition={e => {
            this.props.onShiftPosition(i, e);
          }}
          isMembership={isMembership}
        />
      );
    });

    return (
      <div>
        {this.props.showHeader ? <h2>${isMembership ? "membership" : "pass"} rules</h2> : null}
        {UserStore.hasPermission("edit_pass_bucket") ? (
          <p>
            Use these options to set custom discount rules for particular{" "}
            {this.props.mode === "pass_bucket" ? "events" : "pass types"}.
            {this.props.mode !== "pass_bucket" ? (
              <div style={{ fontWeight: "bold" }}>
                If any rules are added here, all rules configured via pass
                bucket settings will be ignored for this event.
              </div>
            ) : null}
            <InfoNotice style={{ marginTop: 5 }}>
              Check out our{" "}
              <a
                href="http://help.eventive.org/passes/create-pass-rules"
                target="_blank"
              >
                guide to creating {isMembership ? "membership" : "pass"} rules
              </a>
              .
            </InfoNotice>
          </p>
        ) : (
          <p>Custom discount rules</p>
        )}
        {items}
        {UserStore.hasPermission("edit_pass_bucket") ? (
          <RaisedButton
            label="Add new rule"
            onTouchTap={this.onAdd.bind(this, rules.length === 0)}
          />
        ) : null}
      </div>
    );
  }
}

export default connectToStores(PassRulesEditorNonAtomic);



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-rules-editor-nonatomic.jsx